import { useSelector } from "react-redux";

export const useWidth = () => {
  const drawerWidth = useSelector(({ grid }) => grid.drawerWidth);

  return `${drawerWidth}px`;
};
